import { useMemo } from "react";

export const useFieldError = (locatedError, rowId, field) => {
  return useMemo(() => {
    if (!locatedError || locatedError.rowId !== rowId) return [false, ""];
    const message = locatedError.fields?.[field] ?? "";
    return [!!message, message];
  }, [locatedError, rowId, field]);
};